const ISO_DATE_REGEX = /^(\d{4})-(\d{2})-(\d{2})$/;

export const parseIsoDateWithinRange = (
  value?: string | null
): Date | null => {
  if (!value || typeof value !== "string") {
    return null;
  }

  const match = value.match(ISO_DATE_REGEX);
  if (!match) {
    return null;
  }

  const [, yearString, monthString, dayString] = match;
  const year = Number(yearString);
  const month = Number(monthString);
  const day = Number(dayString);

  if (Number.isNaN(year) || Number.isNaN(month) || Number.isNaN(day)) {
    return null;
  }

  if (year < 0 || year > 9999) {
    return null;
  }

  // Months are zero-indexed for the Date constructor.
  const candidate = new Date(year, month - 1, day);

  if (
    candidate.getFullYear() !== year ||
    candidate.getMonth() + 1 !== month ||
    candidate.getDate() !== day
  ) {
    return null;
  }

  return candidate;
};

export const isIsoDateWithinSupportedRange = (
  value?: string | null
): boolean => {
  return parseIsoDateWithinRange(value) !== null;
};
